var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotYet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2a3138;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M909.35,23.71c846.74-61.43,1385.58,873.97,881.1,1558.99-446.47,606.24-1394.92,496.83-1694.81-190.81C-168.14,787.02,245.87,71.84,909.35,23.71ZM1349.78,554.09c-19.34,1.52-43.15,13.79-57.88,26.26l-292.08,290.2-299.64-294.06c-90.94-54.53-184.34,40.1-124.85,128.56l292.62,293.84-298.51,303.55c-62.42,87.46,46.72,188.96,130.65,121.79l296.69-293.97,295.44,289.89c81.91,51.52,174.2-28.08,133.3-116.08l-296.87-302.15,293.44-296.06c56.75-57.55,7.16-158.04-72.31-151.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotYet);
export default __webpack_public_path__ + "static/media/Not Yet.03f576ebed6595e45b01d26ea69b8003.svg";
export { ForwardRef as ReactComponent };